module.exports = __webpack_public_path__ + "static/media/098.9acd7300.jpg";